import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")

  return (_ctx.item.children?.length === 1)
    ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: _ctx.getChildPath(_ctx.item.children[0].path)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.item.children[0].meta.title), 1)
        ]),
        _: 1
      }, 8, ["index"]))
    : (_openBlock(), _createBlock(_component_el_submenu, {
        key: 1,
        index: _ctx.item.path,
        "show-timeout": 100,
        "hide-timeout": 100
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.item.meta.title), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: child.path,
              index: _ctx.getChildPath(child.path)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(child.meta.title), 1)
              ]),
              _: 2
            }, 1032, ["index"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["index"]))
}